import React from 'react';
import { useParams } from 'react-router-dom';
import OrderPage from '../components/orderPage';

// 태블릿 고정 주문 화면 (/tableorder/:storeUid/:tableCode)
// 라우터 파라미터만 뽑아 OrderPage 에 넘기는 얇은 래퍼.
// OrderPage 는 QR 손님 화면과 공용이라 라우터 결합을 넣지 않는다.
const TableOrderPage = () => {
  const { storeUid, tableCode } = useParams();
  return <OrderPage tableOrder={{ storeUid, tableCode }} />;
};

export default TableOrderPage;
